import React from "react";
import Donations from "../models/Donations";
import HelloAsso from "../models/HelloAsso/HelloAsso";
import {BrowserView, MobileView} from 'react-device-detect';
import DonationInfoView from "./DonationInfoView";
import Contact from "../models/Contact";
import ContactEditForm from "../forms/ContactEditForm";
import ContactCreateForm from "../forms/ContactCreateForm";
import TableComponent from "../components/TableComponent";
import { FormControl, Stack, MenuList, MenuItem, Menu, MenuButton, IconButton, Inline, Button, ComboBox, Container, Spinner, Flex, Input, List, ListItem, ListItemText, Typography, Divider } from "@airbus/components-react";
import { MoreHoriz, Visibility, PictureAsPdf, Contacts } from "@airbus/icons/react";

//EVENTBUS
import eventBus from "../eventBus/EventBus";

import "../css/Forms.css";

//PDF
import { PDFViewer } from '@react-pdf/renderer';
import PDFRecuFiscal from "../components/PdfRecuFiscal";

class DonationView extends React.Component {

    constructor(props){
        super(props);
        this.donationsModel = new Donations();   //init Donations model instance
        this.helloAsso = new HelloAsso();
        this.donations_list = [];
        this.filtered_donations_list = [];

        //Notification params
        this.setNotification=this.props.notificationHandler;  //call parent notification handler

        //states
        this.state = {
            donations: [],                      //liste des donations
            recufiscal: {},                     //Donation information for receipt  
            donation: {},                       //DOnation information for more display
            contact: {},                        //Information du contact lié à la donation
            searchContacts: [],                 //Liste contenant noms / prénoms des contacts et id lors de la recherche d'un contact (comboBox)
            selectedContactId:null,             //selected contact lors de la recherche d'un contact
            pdf:false,                          //PDF display   
            donationList: true,                 //Display donation list
            donationInfo: false,                //Display Donation info
            addToContact: false,                //Display Create Contact form
            contactList:false,                  //Display Search Contact ComboBox
            spinner: true,                      //spinner wait
            windowWidth: window.innerWidth,     //screen width 
            windowHeight: window.innerHeight,   //screen height
        }



        //Table Menu
        this.MenuCell = (data) => {
            return (
                <Menu>
                    <MenuButton size="small" variant="ghost" component={IconButton}>
                        <MoreHoriz />
                    </MenuButton>
                    <MenuList>
                        <MenuItem id={data.getValue()} onClick={()=>{this.onViewMoreClick(data.getValue())}} icon={<Visibility />}>
                        Voir plus
                        </MenuItem>
                        <MenuItem id={data.getValue()} onClick={()=>{this.onAddToContactClick(data.getValue())}} icon={<Contacts />}>
                        Ajouter aux contacts
                        </MenuItem>
                        <MenuItem id={data.getValue()} onClick={()=>{this.onGenerateReceiptClick(data.getValue())}} icon={<PictureAsPdf />}>
                        Générer Reçu fiscal
                        </MenuItem>
                    </MenuList>
                </Menu>
            );
        };

        //Table Header
        this.TableColumns = [ 
            { header: "Date", accessorKey: "date", width: 170 },
            { header: "Montant", accessorKey: "montant", width: 100 },
            { header: "Devise", accessorKey: "devise", width: 50 },
            { header: "Type", accessorKey: "type_don", width: 180 },
            { header: "Nom", accessorKey: "nom", width: 100 },
            { header: "Prénom", accessorKey: "prenom", width: 100 },
            { header: "Statut", accessorKey: "status", width: 100 },
            { header: "Reçu fiscal", accessorKey: "recu_fiscal", width: 100 },
            { header: "", accessorKey:"id", cell: this.MenuCell, width: 70 }
        ]; 



    }


    componentDidMount=async()=> {
        
        //Manage screen size
        window.addEventListener("resize", this.handleResize);
        
        //retrieve donations list
        await this.getDonations();     

        //retrieve donations from Hello Asso
        await this.helloAsso.getToken();
        
        let organization = await this.helloAsso.getOrganization()
        debugger;
        console.log(organization);

        //Retrieve list of Hello Asso Donations
        let ha_orders = await this.helloAsso.getOrders()
        debugger;
        console.log(ha_orders);


        //Listener Go back to list view after submit update Contact
        eventBus.on("contactlistview", (data) => {          
            if(data['contactlistview'] === true){
                
                this.setState({pdf:false});
                this.setState({donationList:true});
                this.setState({donationInfo:false});
                this.setState({addToContact:false});
                

                //Display success banner
                this.setNotification(true,{
                    notifVariant: "success",
                    notifMessage:"Contact modifié avec succès",
                    notifDescription: null
                  });

            }

        
        });

        this.setState({spinner:false});

    }

    /*Handle screen size*/
    handleResize = (e) => {
        this.setState({ 
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight
        });
    
        };

    
    /**
     * RENDERING
     * @returns dom
     */
     render() { return(
         <Container style={{height:this.state.windowHeight-150, paddingTop:'10px'}}>

            
            {/**SPINNER WAIT */}
            {this.state.spinner &&
            <Flex justify="left"style={{paddingTop:"25px"}}>
                <Spinner dots/>
            </Flex>
            }
            
            {/* DATATABLE DISPLAY */}
            
            {this.state.donationList && !this.state.spinner &&
                <div>
                    {/* BROWSER MODE */}
                    <BrowserView>
                        <TableComponent columns={this.TableColumns} data={this.state.donations} />
                    </BrowserView>
                    {/* MOBILE MODE */}
                    <MobileView>
                        <Container until='xl'>
                            <Input style={{width:'150px'}} placeholder="Rechercher" onChange={this.handleChangeSearch}/>
                        </Container>
                        <Container until='xl' style={{width:"100%"}}>
                            <Flex wrap justify='left' spacing='2-x'>
                                <List style={{height:"80%",  width:'100%'}}>
                                {this.state.donations.map((key, i)=>(
                                    <div style={{width:'100%'}}>
                                        <ListItem
                                            key={key.id}
                                            style={{lineHeight:2, width:'100%'}}
                                            onClick={()=>{this.onViewMoreClick(key.id)}}
                                        >
                                            <Stack>
                                                <ListItemText>
                                                    <Inline spacing="2-x">
                                                        <div><Typography variant="h7">Date</Typography></div>
                                                        <div><Typography variant="h7">{key.date}</Typography></div>
                                                    </Inline>
                                                </ListItemText>
                                                <ListItemText>
                                                    <Inline spacing="2-x">
                                                        <div><Typography variant="h7">Montant</Typography></div>
                                                        <div><Typography variant="h7">{key.montant} {key.devise}</Typography></div>
                                                    </Inline>
                                                </ListItemText>
                                                <ListItemText>
                                                    <Inline spacing="2-x">
                                                        <div><Typography variant="h7">Type</Typography></div>
                                                        <div><Typography variant="h7">{key.type_don}</Typography></div>
                                                    </Inline>
                                                </ListItemText>
                                                <ListItemText>
                                                    <Inline spacing="2-x">
                                                        <div><Typography variant="h7">Nom</Typography></div>
                                                        <div><Typography variant="h7">{key.nom} {key.prenom}</Typography></div>
                                                    </Inline>
                                                </ListItemText>
                                                <ListItemText>
                                                    <Inline spacing="2-x">
                                                        <div><Typography variant="h7">Statut</Typography></div>
                                                        <div><Typography variant="h7">{key.status}</Typography></div>
                                                    </Inline>
                                                </ListItemText>
                                                <ListItemText>
                                                    <Inline spacing="2-x">
                                                        <div><Typography variant="h7">Reçu fiscal</Typography></div>
                                                        <div><Typography variant="h7">{key.recu_fiscal}</Typography></div>
                                                    </Inline>
                                                </ListItemText>
                                                
                                            </Stack>
                                        </ListItem>
                                        <Divider/>
                                    </div>
                                ))}
                                </List>
                            </Flex>
                        </Container>
                    </MobileView>
                </div>
            }
            
            {/* PDF RENDERING */}
            {this.state.pdf 
            ?
                (this.state.contact.nom !== '' && this.state.contact.nom !== null
                    && this.state.contact.prenom !== '' && this.state.contact.prenom !== null
                    && this.state.contact.adresse1 !== '' && this.state.contact.adresse1 !== null
                    && this.state.contact.codepostal !== '' && this.state.contact.codepostal !== null
                    && this.state.contact.ville !== '' && this.state.contact.ville !== null)?

                
                <PDFViewer width={1000} height={400}>
                    <PDFRecuFiscal data={this.state.recufiscal} contact={this.state.contact}/>
                </PDFViewer>
                :
                //* EDIT CONTACT DISPLAY if some info contact is missing*//
                <ContactEditForm id={this.state.contact.id}
                            name={this.state.contact.nom}
                            firstname={this.state.contact.prenom}
                            mail={this.state.contact.mail}
                            phone={this.state.contact.telephone}
                            adresse1={this.state.contact.adresse1}
                            adresse2={this.state.contact.adresse2}
                            postcode = {this.state.contact.codepostal}
                            city = {this.state.contact.ville}
                            comment = {this.state.contact.commentaire} />

            :null}

            {/* DONATION VIEW MORE DISPLAY */}
            {this.state.donationInfo ?
                <DonationInfoView donation={this.state.donation} />
            :null}

            {/* DONATION ADD TO CONTACT */}
            {this.state.addToContact ?
                <div>
                
                <ContactCreateForm
                    name={this.state.donation.nom}
                    firstname = {this.state.donation.prenom}
                    mail = {this.state.donation.mail}
                    adresse1 = {this.state.donation.billing_address1}
                    adresse2 = {this.state.donation.billing_address2}
                    postcode = {this.state.donation.billing_zip}
                    city = {this.state.donation.billing_city}
                />
                <Inline spacing="1-x" align="center" >
                <Button variant="primary" 
                    onClick = {this.onRetour}
                    style={{
                        width: "150px"
                        
                        }}>
                    RETOUR
                </Button>
                </Inline>
                </div>

            :null}

            {/* SEARCH CONTACT DISPLAY */}
            {this.state.contactList ?
                

                <div >
                    
                    <Inline spacing="3-x" align="center" style={{marginTop: '15px'}}>
                        <ComboBox 
                            style = {{width:'350px'}}
                            placeholder="Rechercher un contact pour générer le reçu fiscal"
                            options={this.state.searchContacts}
                            getOptionLabel = {(option) => option.name_firstname}
                            getOptionValue = {(option) => option.id}
                            onChange = {(selectedItem) => this.setState({selectedContactId:selectedItem})}
                        />
                    </Inline>
                    
                </div>
            :null}
            


            {/* BOUTON RETOUR DEPUIS PDF VIEW*/}
            {this.state.pdf || this.state.donationInfo || this.state.contactList ?
                <Inline spacing="3-x" align="center" >
                    
                    {this.state.contactList ?
                        <Container until="sm" className="container-left" style={{paddingLeft:"0px"}}>
                            <Flex wrap={true} direction="row" >
                            <FormControl
                                className="button-controlForm"
                                >
                                <Button variant="primary" 
                                    onClick = {this.onSelectedContact}
                                    style={{
                                        width: "100%"
                                        }}>
                                    GENERER RECU FISCAL
                                </Button>
                                </FormControl>
                            </Flex>
                        </Container>
                    :null}
                    <Container until="sm" className="container-left" style={{paddingLeft:"0px"}}>
                    <Flex wrap={true} direction="row" >
                        <FormControl
                            className="button-controlForm"
                        >
                        <Button variant="primary" 
                            onClick = {this.onRetour}
                            style={{
                                width: "100%"
                                }}>
                            RETOUR
                        </Button>
                        </FormControl>
                    </Flex>
                    </Container>
                </Inline>
            :null}

            

         </Container>
     )}

    /**
     * 
     * FUNCTIONS
     * 
     *  */ 

    //Handle on change search input box
    handleChangeSearch=(event) =>{
        const value = event.target.value;

        //Filter Data Table
        let _ = require('underscore');
        debugger;
        let filtered_data = _.filter(this.donations_list,function(item){

            let found=false;
            Object.keys(item).forEach(function(key) {
                
                if (item[key] === undefined || typeof item[key]=== 'object'){
                    /*skip undefined keys*/
                }
                
                else if(!isNaN(item[key]) || !isNaN(value) ){
                    
                    
                    if(item[key].toString().includes(value.toString())===true){
                        found = true;

                    }
                }
                else if(item[key].toLowerCase().includes(value.toLowerCase())===true){
                    found = true;
                }
                
            });
            return found === true;

        });

        this.filtered_donations_list=filtered_data; //update filtered data    

        if (this.filtered_donations_list.length > 0){
            this.setState({donations: filtered_data})
        }else{
            this.setState({donations: []})
        }


        
    }

    getDonations = async () => {
        //Retrieve list of donations
        let list = await this.donationsModel.getDonations();

        if(list === undefined){
            //API return error
            this.setNotification(true,{
                notifVariant: "error",
                notifMessage:"Erreur lors de la récupération de la liste de dons",
                notifDescription: null
              });

        }else{
            this.donations_list = list;
            this.setState({donations:list});
        }

        //console.log(list);
    }

    getReceiptById = async(id) => {

        //Retrieve list of donations
        let list = await this.donationsModel.getDonationByID(id);

        if(list === undefined){
            //API return error
            this.setNotification(true,{
                notifVariant: "error",
                notifMessage:"Erreur lors de la génération du reçu fiscal",
                notifDescription: null
              });

        }else{
            
            //On récupère les informations du contact s'il existe
            if (list[0].mail !== '' && list[0].mail !== null && list[0].mail !== undefined){
                let contact = new Contact();
                let contactData = await contact.getContactByMail(list[0].mail);
                
                this.setState({contact:contactData});   //keep in memory

                //Contact existant ?
                if (contactData.id === null){
                    //Pas de contact existant
                    //Sélection manuelle
                    let contactNames = await contact.searchContacts();
                    this.setState({searchContacts:contactNames});
                    this.setState({donationList: false});
                    this.setState({contactList:true});
                    this.setState({recufiscal:list[0]});
                    
                    this.setNotification(true,{
                        notifVariant: "warning",
                        notifMessage:"Le reçu fiscal ne peut pas être généré correctement",
                        notifDescription: "Le système n'a pas pu retrouver les informations du contact."
                      });

                }else{

                    //Vérification que l'on dispose des infos nécessaires
                    let msg=''
                    if(contactData.nom === ''){
                        msg+=' Nom,'
                    }
                    if(contactData.prenom === ''){
                        msg+=' Prénom,'
                    }
                    if(contactData.adresse1 === ''){
                        msg+=' Adresse,'
                    }
                    if(contactData.codepostal === ''){
                        msg+=' Code Postal,'
                    }
                    if(contactData.ville === ''){
                        msg+=' Ville,'
                    }
                    
                    if(msg !== ''){
                        this.setNotification(true,{
                            notifVariant: "warning",
                            notifMessage:"Le reçu fiscal ne peut pas être généré correctement",
                            notifDescription: 'Vérifier les informations du contact: '+msg
                          });
                        
                    }

                    this.setState({recufiscal:list[0]});
                    this.setState({pdf:true});
                    this.setState({donationList:false});
                    this.setState({donationInfo:false});
                }

            }
            else{
                
                
                //Le reçu fiscal ne comporte pas de mail de contact permettant de lier aux contacts en BD
                //Sélection manuelle
                let contact = new Contact();
                let contactNames = await contact.searchContacts();
                this.setState({searchContacts:contactNames});
                this.setState({contact:{}});
                this.setState({donationList: false});
                this.setState({contactList:true});
                this.setState({recufiscal:list[0]});
                

                this.setNotification(true,{
                    notifVariant: "warning",
                    notifMessage:"Le reçu fiscal ne peut pas être généré correctement",
                    notifDescription: "Le système n'a pas pu retrouver les informations du contact."
                  });
                
                
            }

            
        }
    }


    getDonationById = async(id) => {
        //Retrieve list of donations
        this.setState({spinner: true});

        let list = await this.donationsModel.getDonationByID(id);

        let comment = await this.donationsModel.getDonationDonorCommentHistory(id);

        
        if(list === undefined){
            //API return error
            this.setNotification(true,{
                notifVariant: "error",
                notifMessage:"Erreur lors de la récupération des informations du don",
                notifDescription: null
              });

        }else{
            
            let donation=list[0];
            //add optional comments
            donation['donor_comment']=comment;

            this.setState({donation:donation});
            this.setState({pdf:false});
            this.setState({donationList:false});
            this.setState({addToContact:false});
            this.setState({donationInfo:true});
        }

        this.setState({spinner: false});
    }

    /*Génération du reçu fiscal*/
    onGenerateReceiptClick = async (selectedId) =>{
        
        //get donation id
        //let selectedId =  e.target.closest("li").id; //get selected contact
        this.getReceiptById(selectedId);



    }

    onViewMoreClick = async (selectedId) =>{
         //get donation id
         //let selectedId =  e.target.closest("li").id; //get selected contact
         
         this.getDonationById(selectedId);
         

    }

    

    /**
     * 
     * EVENTS
     * 
     *  */

     onRetour = () =>  {
         this.setState({pdf:false});
         this.setState({donationInfo:false});
         this.setState({addToContact:false});
         this.setState({donationList:true});
         this.setState({contactList:false});
     }

     //Event when contact has been manually selected
     onSelectedContact = async (event) =>{
        
        
        debugger;
        let contactid = this.state.selectedContactId.id;
        
        //retrive contact Data for receipt generation
        let contact = new Contact();
        let contactData = await contact.getContactById(contactid);
        
        this.setState({contact:contactData});
        this.setState({pdf:true});
        this.setState({donationList:false});
        this.setState({donationInfo:false});
        this.setState({addToContact:false});
        this.setState({contactList:false});

        if (contactData.adresse1 === '' || contactData.codepostal === '' || contactData.ville === ''){
            
            let msg=''
            if(contactData.adresse1 === ''){
                msg+=' Adresse,'
            }
            if(contactData.codepostal === ''){
                msg+=' Code Postal,'
            }
            if(contactData.ville === ''){
                msg+=' Ville,'
            }
            
            this.setNotification(true,{
                notifVariant: "warning",
                notifMessage:"Le reçu fiscal ne peut pas être généré correctement",
                notifDescription: 'Vérifier les informations du contact: '+msg
              });
            
        }

        
     }

     //Ajouter donateur aux contacts
     onAddToContactClick = async (selectedId) =>{

         //get donation id
         //let selectedId =  event.target.closest("li").id; //get selected id

         //Get Donation info
         let list = await this.donationsModel.getDonationByID(selectedId);

         if(list!== undefined && list.length >0){
            this.setState({donation:list[0]});

            this.setState({pdf:false});
            this.setState({donationInfo:false});
            this.setState({donationList:false});
            this.setState({contactList:false});
            this.setState({addToContact:true});


         }else{
            this.setNotification(true,{
                notifVariant: "error",
                notifMessage:"Erreur lors de la récupération des informations du don",
                notifDescription: null
              });
            
         }


         



     }

}
export default DonationView; 